<template>
<div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2">
  <label :for="fieldPath" class="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">{{ fieldLabel }}</label>
  <div class="mt-2 sm:col-span-2 sm:mt-0">
    <input :value="formattedModelValue" @input="$emit('update:modelValue', $event.target.value)" v-bind="fieldAttrs" type="date" :name="fieldPath" :id="fieldPath"
      class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:max-w-xs sm:text-sm/6 invalid:outline-red-600 invalid:focus:outline-red-600" />
    <p v-if="errors[fieldPath]" class="text-sm text-red-600">{{ errors[fieldPath] }}</p>
  </div>
</div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps(["modelValue", "fieldPath", "fieldAttrs", "fieldLabel", "errors"]);

const formattedModelValue = computed(() => {
  return props.modelValue? new Date(props.modelValue).toISOString().split("T")[0] : "";
});
</script>
